// @ts-nocheck
import { motion } from 'framer-motion';
import { YStack, XStack, Text } from 'tamagui';
import { Container } from './Container';
import { useIsMobile } from '../hooks/useIsMobile';

const MotionDiv = motion.div;

export function Hero() {
  const isMobile = useIsMobile();

  return (
    <YStack paddingTop={isMobile ? '$8' : '$11'} paddingBottom={isMobile ? '$8' : '$10'}>
      <Container>
        <MotionDiv
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 20 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Text
            fontSize={isMobile ? 40 : 56}
            fontWeight="700"
            letterSpacing={-1.5}
            lineHeight={isMobile ? 46 : 64}
            color="$color12"
            maxWidth={650}
          >
            Infrastructure for work that runs itself.
          </Text>

          <Text
            fontSize={isMobile ? '$5' : '$6'}
            color="$color8"
            lineHeight={isMobile ? 26 : 30}
            maxWidth={560}
          >
            Search, AI governance, financial data, and the ledger underneath it — on one
            shared platform. Identity, billing, and permissions solved once, so every
            product starts at the feature layer.
          </Text>

          {/* Stats */}
          <XStack flexDirection="row" gap={isMobile ? '$6' : '$10'} marginTop="$4">
            {[
              { num: '4', label: 'Products' },
              { num: '4', label: 'Open source' },
              { num: '25+', label: 'Microservices' },
            ].map((s) => (
              <YStack key={s.label} gap="$1">
                <Text fontSize={isMobile ? 24 : 28} fontWeight="700" color="$color12">{s.num}</Text>
                <Text fontSize="$2" color="$color8">{s.label}</Text>
              </YStack>
            ))}
          </XStack>
        </MotionDiv>
      </Container>
    </YStack>
  );
}
